import { render, staticRenderFns } from "./BatchEndpointView.vue?vue&type=template&id=243c30fe"
import script from "./BatchEndpointView.vue?vue&type=script&lang=js"
export * from "./BatchEndpointView.vue?vue&type=script&lang=js"
import style0 from "./BatchEndpointView.vue?vue&type=style&index=0&id=243c30fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports